<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <slotbar fluid align='center' :slots='2' :slotWidth='400'>
          <template v-slot:slot1>
            <h1>{{title}}</h1>
          </template>
          <template v-slot:slot2>
            <v-btn color='primary' style='margin: 2px' @click='openKeyListDialog'>
              Agregar Llaves<v-icon>mdi-key-chain-variant</v-icon>
            </v-btn>
            <v-btn v-if='!docSigned' color='primary' style='margin: 2px' @click='clickFirmarButton'>
              Firmar<v-icon>mdi-fountain-pen-tip</v-icon>
            </v-btn>
            <AlgFirma v-if="!docSigned" :selected="selected" :hasKey="hasSelectedKey" :docId="documento.id" @signedSuccessfully="onSignSuccess" ref='algFirmaComponent' hidden></AlgFirma>
          </template>
        </slotbar>
      </v-card-title>
      <v-card-text></v-card-text>
      <v-card-text v-if='!docSigned && hasSelectedKey'>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols='11' sm='9' md='6' lg='5' xl='4'>
            <v-card color='#fefeff'>
              <v-card-title>Llave seleccionada:</v-card-title>
              <v-card-text></v-card-text>
              <v-card-text>Nombre: {{ selected[0].short }}</v-card-text>
              <v-card-text>Serial: {{ selected[0].serial }}</v-card-text>
              <v-card-text>Emisor: {{ selected[0].isshort }}</v-card-text>
            </v-card>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-card-text>
      <v-card-text>
        <VerContrato :loaded="true" :documentoInit="documento" :showTitleInit="true"></VerContrato>
        <div style="margin-bottom: 10%" class='text-center'>
          <v-btn v-if='!docSigned' color='primary' @click='clickFirmarButton'>
            Firmar<v-icon>mdi-fountain-pen-tip</v-icon>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>

    <v-dialog v-model='keyListDialog'>
      <v-card>
        <v-card-title class="headline grey lighten-2">Seleccione una llave{{docSigned ? '' : ' para firmar'}}</v-card-title>
        <v-card-text>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="filteredKeyList"
            item-key="serial"
            show-select
            single-select
            @click:row="rowSelected"
            :options.sync='options'
            :footer-props='{
              itemsPerPageOptions: [5, 10, 20, 50]
            }'
            no-data-text="No hay llaves disponibles">
            <template v-slot:top>
              <slotbar fluid :visible='keyListDialog' :slots='2' :slotWidth='500'>
                <template v-slot:slot2>
                  <v-btn color="primary" style="margin: 2px;" type="icon" @click="upload">
                    Agregar llave<v-icon>mdi-key-variant</v-icon>
                  </v-btn>
                </template>
                <template v-slot:slot1>
                  <v-btn color="primary" style="margin: 2px;" type="icon" :disabled='!hasSelectedKey' @click="confirm">
                    Eliminar Llave<v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <v-btn color="primary" style="margin: 2px;" type="icon" :disabled='!hasKeys' @click="confirmMult">
                    Eliminar Todas las Llaves<v-icon>mdi-alert</v-icon>
                  </v-btn>
                </template>
              </slotbar>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div v-if='!docSigned'>
            <v-btn @click='closeKeyListDialog(false)' :disabled='!hasSelectedKey' text color='primary'>Aceptar</v-btn>
            <v-btn @click='closeKeyListDialog(true)' text color='primary'>Cancelar</v-btn>
          </div>
          <v-btn v-if='docSigned' @click='closeKeyListDialog(true)' text color='primary'>Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="llaveDialog" max-width="800px">
      <v-card>
        <v-card-title class="headline grey lighten-2" style="padding-left: 15%">
          Agregar Certificado y Llave
        </v-card-title>
        <v-card-text>
          <ParseEfirma @PrivateKeyUploadEvent="privateKeyHandler" v-if="mode == 'upload'"></ParseEfirma>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" max-width="320">
      <v-card>
        <v-card-title v-if="multiple" class="headline">Borrar Todas las llaves</v-card-title>
        <v-card-title v-else class="headline">Borrar llave</v-card-title>

        <v-card-text v-if="multiple">
          Una vez borradas las llaves tendrá que introducirlas nuevamente para usarlas.
          ¿Eliminar llaves?
        </v-card-text>

        <v-card-text v-else>
          Una vez borrada la llave tendrá que introducirla nuevamente para usarla.
          ¿Eliminar llave?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="dialog = false">Cancelar</v-btn>

          <v-btn v-if="multiple" color="primary" text @click="eliminarTodasLasLlaves()">Aceptar</v-btn>

          <v-btn v-else color="primary" text @click="eliminarLlave()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import AlgFirma from '@/components/firma/algoritmoFirma.vue'
import ParseEfirma from './ParseEfirma'
import VerContrato from '@/components/contrato/verContrato.vue'
import slotbar from '@/components/custom/slotbar.vue'
import * as jsrsasign from 'jsrsasign'
import { mapActions, mapGetters } from 'vuex';
import { parseXml, xml2json } from '@/utils/xml2json.js';
import { incompleteQuery, isEmptyVariable } from '@/utils/checkQuery.js';
import { consoleErrorMessage, toasterErrorMessage } from '@/utils/responseCatchMessages.js';
import { ApiInit } from '@/api.js';

export default {
  name: 'SelectPrivateKey',
  components: {
    ParseEfirma,
    AlgFirma,
    VerContrato,
    slotbar,
  },
  data () {
    return {
      // title: '',
      msg: '',
      key: {name: '', serial: '', issuer: '', cert: '', key: ''},
      mode: 'list',
      myImage: require('@/assets/icon.png'),
      dialog: false,
      multiple: false,
      llaveDialog: false,
      keyListDialog: false,
      previousSerial: '',
      selected: [],
      keyList: [],
      filteredKeyList: [],
      headers: [
        { text: 'Nombre', value: 'short'},
        { text: 'Serial', value: 'serial'},
        { text: 'Emisor', value: 'isshort' },
      ],
      options: {
        itemsPerPage: 5,
      },
      documento: {
        id: '',
        cliente: {},
      },
      docSigned: true,
    }
  },
  computed: {
    hasKeys() {
      if (this.filteredKeyList.length > 0) return true;
      return false;
    },
    title() {
      if (this.docSigned) return 'Revisar Documento';
      return 'Firmar Documento';
    },
    hasSelectedKey() {
      if (this.selected.length > 0) return true;
      return false;
    }
  },
  mounted(){
    ApiInit().then(r => this.init() );
  },

  methods: {
    ...mapActions(['setClient', 'setDocument', 'setCerts']),
    ...mapGetters(['getClient', 'getDocument', 'getCerts', 'getKey', 'getUser']),
    
    async init(){
      this.getKeyList();
      const query = this.$route.query;
      const requiredParams = ['c', 'd'];
      let fromQuery = false;
      if (!incompleteQuery(query, requiredParams)) {
        fromQuery = true;
        await this.getDocumentoById(query.c, query.d);
      }
      else if (!isEmptyVariable(this.$route.params) && !isEmptyVariable(this.$route.params.documento)) {
        this.documento = this.$route.params.documento;
        this.setClient(this.documento.cliente.id);
        this.setDocument(this.documento.id);
      } else {
        this.documento.cliente.id = this.getClient();
        this.documento.id = this.getDocument();
        await this.getDocumentoById(this.documento.cliente.id, this.documento.id);
      }
      this.getContenidoDocumento(this.documento.cliente.id, this.documento.id);
      if (fromQuery && isEmptyVariable(query.f)) return;
      if (typeof this.documento.status === 'string' && this.documento.status === 'FIRMADO') this.docSigned = true;
      else this.docSigned = false;
    },
    
    privateKeyHandler (pk) {
      console.debug('selectpk: %o', pk)
      if (!pk) {
        this.mode = 'list'
        this.llaveDialog = false;
        return
      }
      let k = Object.assign({}, this.key)
      k.name = pk.name
      k.short = pk.name.split("/")
      k.short.forEach(n =>{
        if(n.substring(0,3) == 'CN='){
          k.short = n.substring(3, n.length);
        }
      })
      k.serial = pk.serial
      k.issuer = pk.issuer
      k.isshort = pk.issuer.split("/")
      k.isshort.forEach(c =>{
        if(c.substring(0,2) == 'O='){
          k.isshort = c.substring(2, c.length);
        }else if(c.substring(0,3) == 'CN='){
          k.isshort = c.substring(3, c.length);
        }
      })
      
      k.cert = this.PemToBase64(jsrsasign.KJUR.asn1.ASN1Util.getPEMStringFromHex(pk.cer.hex, ''))
      //k.key = pk.key
      k.keyO = this.getKey();
      k.expire = new Date().getTime() + 43200000;
      k.username = this.getUser().username;
      k.save = pk.save;
      console.log("KEYPRUEBA: %o", pk.key);
      if(this.checkList(k.serial, k.username)){
        this.keyList.push(k)
        this.setCerts(this.keyList)
        this.getFilteredKeyList();
        this.$toast.success("Llave agregada exitosamente.")
      }else{
        this.$toast.error("Llave repetida");
      }
      this.mode = 'list'
      this.llaveDialog = false
      //this.$emit('PrivateKeySelectedEvent', pk)
    },
    checkList(serie, usuario){
      const list = this.getCerts();
      console.log("Lista: %o", list);
      var request = true;
      list.forEach(k =>{
        console.log("llave: %o", k.serial);
        if(k.serial == serie && k.username == usuario){
          console.log("Revisado");
          request = false;
        }
      });
      return request;
    },
    upload (event) {
      this.mode = 'upload'
      this.llaveDialog = true;
    },
    sign (event) {
      let md = new jsrsasign.KJUR.crypto.MessageDigest({ alg: 'sha1' })
      md.updateString('aaa')
      var mdHex = md.digest()
      console.debug('md: %o', mdHex)
      let sig = new jsrsasign.KJUR.crypto.Signature({alg: 'SHA1withRSA'})
      console.debug('sig: %o', sig)
      sig.init(this.keyList[0].key)
      sig.updateString('aaa')
      var sigVal = sig.sign()
      console.debug('sigVal: %o', sigVal)
    },
    async getDocumentoById(clienteId, docId) {
      const defaultToastMessage = 'Error al cargar el documento.';
      const defaultConsoleMessage = 'getDocumentoById error';
      try {
        const response = await this.$store.dispatch('getDocumento', {clienteId, docId});
        if (response === null) {
          console.error(defaultConsoleMessage);
          this.$toast.error(defaultToastMessage);
          return;
        }
        this.documento = response;
      } catch (e) {
        consoleErrorMessage(e, defaultConsoleMessage);
        toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
      }
    },
    getDownloadType(type) {
      if (type === 'XMLBasic') return 'XML';
      return type;
    },
    async getContenidoDocumento(clienteId, docId) {
      const defaultToastMessage = 'Error al cargar el documento.';
      const defaultConsoleMessage = 'getContenidoDocumento error';
      try {
        let docTemp = JSON.parse(JSON.stringify(this.documento));
        const isPdf = (docTemp.type === 'PDF' ? true : false);
        const downloadType = this.getDownloadType(docTemp.type);
        const methodName = (isPdf ? 'downloadDocumento' : 'getDocumentHtml');
        const response = await this.$store.dispatch(methodName, {clienteId, docId, downloadType});
        if (response === null) {
          console.error(defaultConsoleMessage);
          this.$toast.error(defaultToastMessage);
          return;
        }
        const propName = (isPdf ? 'pdfBlob' : 'doc');
        docTemp[propName] = (isPdf ? response.data : new Blob([response.data], {type: 'text/html'}));
        this.documento = docTemp;
      } catch (e) {
        consoleErrorMessage(e, defaultConsoleMessage);
        toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
      }
    },
    onSignSuccess() {
      this.docSigned = true;
      this.getContenidoDocumento(this.documento.cliente.id, this.documento.id);
    },
    getKeyList() {
      try {
        // console.debug('$store.getters.getCerts', this.getCerts());
        this.setCerts(this.getCerts());
        this.keyList = this.getCerts();
      } catch (e) {
        console.error('getKeyList error: %o', e);
        this.$toast.error('Error al obtener lista de llaves y certificados.');
      }
      this.getFilteredKeyList();
    },
    getFilteredKeyList() {
      const username = this.getUser().username;
      this.filteredKeyList = [];
      for (const key of this.keyList) {
        if (key.username === username) this.filteredKeyList.push(key);
      }
    },
    confirm(){
      this.dialog = true;
      this.multiple = false;
    },
    confirmMult(){
      this.dialog = true;
      this.multiple = true;
    },
    eliminarLlave() {
      if (this.selected.length === 0) return;
      const serial = this.selected[0].serial;
      const username = this.getUser().username;
      for (const index in this.keyList) {
        if (this.keyList[index].serial === serial && this.keyList[index].username === username) {
          this.keyList.splice(index, 1);
          if (this.previousSerial === serial) this.previousSerial = '';
          break;
        }
      }
      this.getFilteredKeyList();
      this.selected = [];
      this.setCerts(this.keyList);
      this.dialog = false;
    },
    eliminarTodasLasLlaves() {
      const username = this.getUser().username;
      let indexArray = [];
      for (const index in this.keyList) {
        if (this.keyList[index].username === username) indexArray.push(index);
      }
      for (const index of indexArray.reverse()) this.keyList.splice(index, 1);
      this.previousSerial = '';
      this.getFilteredKeyList();
      this.selected = [];
      this.setCerts(this.keyList);
      this.dialog = false;
    },
    PemToBase64(PemString) {
      let lines = PemString.split('\r\n')
      let bStr = ''
      for (let i = 1; i < lines.length - 2; i++) {
        bStr += lines[i]
      }
      return bStr;
    },
    rowSelected(obj) {
      // console.debug('rowSelected object %o', obj);
      if (this.selected.length > 0) {
        const sel = this.selected[0];
        this.selected = [];
        if (sel.serial !== obj.serial) this.selected.push(obj);
      } else this.selected.push(obj);
    },
    clickFirmarButton() {
      if (!this.hasSelectedKey) {
        this.$toast.info('Seleccione una llave para firmar');
        return;
      }
      if (!this.docSigned) this.$refs.algFirmaComponent.$refs.algFirmaActivator.$el.click();
    },
    openKeyListDialog() {
      this.keyListDialog = true;
      if (this.hasSelectedKey) this.previousSerial = this.selected[0].serial;
    },
    closeKeyListDialog(cancel) {
      if (cancel) {
        const previousKey = this.findKeyBySerial(this.previousSerial);
        this.selected = [];
        if (previousKey !== null) this.selected.push(previousKey);
      }
      this.keyListDialog = false;
    },
    findKeyBySerial(serial) {
      if (serial.length === 0) return null;
      for (const key of this.filteredKeyList) {
        if (key.serial === serial) return key;
      }
    },
  },
};
</script>
<style scoped>
.selectpk { border: none; margin-top: 20px;}
.button{
  background-color: red;
  margin-right: 20px;
}
</style>
